import React from 'react';
import { Link } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

import Estado from './Estado.jsx';
import TableRowCheckBox from './TableRowCheckBox.jsx';

const TableRow = (props) => {
    let classCheckSelected = (props.isChecked == true) ? "checked" : "";

    return (
        <tr className={classCheckSelected}>
            <td>
                <TableRowCheckBox
                    id={props.ID}
                    isChecked={props.isChecked}
                    isCurrentUser={props.isCurrentUser}
                    setCheckbox={props.setCheckbox}
                />
            </td>
            <td>
                {!props.isCurrentUser &&
                    <Link to={ProcessManager.GetNextStep("ListaDeUsuarios", "ROUTE_TO_VISTA_USUARIO") + '/' + props.ID} className="link-no-decoration">
                        <div>
                            <label className="label-primary clickable with-hover">{props.nombre}</label>
                        </div>
                    </Link>
                }
                {props.isCurrentUser &&
                    <div>
                        <label className="label-primary clickable with-hover">{props.nombre}</label>
                    </div>
                }
            </td>
            <td>
                <label className="label-primary">{props.login}</label>
            </td>
            <td>
                <label className="label-primary">{props.sucursal}</label>
            </td>
            <td>
                <label className="label-primary">{props.sector}</label>
            </td>
            <td >
                <Estado
                    estado={props.estado}
                    ID={props.ID}
                    motivo={props.motivo}
                    usuario={props.login}
                    bloqueadoPor={props.bloqueadoPor}
                    fechaBloqueado={props.fechaBloqueado}
                    horaBloqueado={props.horaBloqueado}
                    eliminadoPor={props.eliminadoPor}
                    fechaEliminado={props.fechaEliminado}
                    horaEliminado={props.horaEliminado}
                    functions={props.functions}
                    setUserState={props.setUserState}
                    bloqueado_inactividad={props.bloqueado_inactividad}
                />
            </td>
        </tr>
    );
}

export default TableRow;